import { Stack, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AppLoader from "../../../components/apploader";
import GlobalButton from "../../../components/button";
import CustomContainer from "../../../components/container/CustomContainer";
import DashboardHeader from "../../../components/dashboardHeader";
import DynamicTable from "../../../components/table";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import WithdrawAmountDialog from "./WithdrawAmountDialog";
import {
  getUserDetailById,
  getUserWithdrawRequest,
} from "../../../services/userDetailFn";
import { t } from "i18next";

const headerData = ["requestedAt", "amount", "status", "reason", "receipt"];

const tableRows = [
  "date_time",
  "withdraw_amount",
  "withdraw_status",
  "withdraw_reason",
  "withdraw_receipt",
];

const UserWithdrawRequestPage = () => {
  const openWithdrawDialogRef = useRef();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [allRequest, setAllRequest] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const userData = useSelector((state) => state.userReducer.user);

  useEffect(() => {
    if (userData) {
      fetchUserDataAndWithdrawRequests();
    }
  }, [userData]);

  const fetchUserDataAndWithdrawRequests = async () => {
    try {
      setIsLoading(true);

      const [packageResponse, userDetailResponse] = await Promise.all([
        getUserWithdrawRequest(userData?._id),
        getUserDetailById(userData?._id),
      ]);

      if (packageResponse.data.status === "success") {
        setAllRequest(packageResponse.data.data);
      }
      if (userDetailResponse.data.status === true) {
        setUserDetails(userDetailResponse.data.data);
      }
    } catch (error) {
      showSnackbar(error?.message || "Failed to fetch data", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const renderHeader = () => {
    return (
      <Stack gap={2} direction={{ xs: "column", sm: "row" }}>
        <GlobalButton
          btnText={`${t("walletAmount")}: ${
            userDetails?.wallet?.toFixed(2) || 0
          }`}
          handleClickBtn={() =>
            openWithdrawDialogRef.current.openDialog({
              getData: fetchUserDataAndWithdrawRequests,
            })
          }
          styleProps={{
            width: { xs: "100%", sm: "auto" },
            height: 40,
          }}
        />
        <GlobalButton
          btnText={`requestWithdraw`}
          handleClickBtn={() =>
            openWithdrawDialogRef.current.openDialog({
              getData: fetchUserDataAndWithdrawRequests,
            })
          }
          styleProps={{
            width: { xs: "100%", sm: "auto" },
            height: 40,
          }}
        />
      </Stack>
    );
  };

  return (
    <DashboardHeader>
      <AppLoader isVisible={isLoading} />
      <CustomContainer
        primaryHeading={t("withdrawRequest")}
        secondaryHeading={t("withdrawRequestDescription")}
        showBackButton={true}
        handleBack={() => navigate("/dashboard")}
        headProps={renderHeader()}
      >
        <DynamicTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allRequest}
        />

        {allRequest.length === 0 && !isLoading && (
          <Typography variant="h6" textAlign={"center"} fontWeight={600} mt={2}>
            {t('noWithdrawRequestsFound')}.
          </Typography>
        )}
      </CustomContainer>
      <WithdrawAmountDialog ref={openWithdrawDialogRef} />
    </DashboardHeader>
  );
};

export default UserWithdrawRequestPage;
